/*
 * Ryan O'Dowd
 * 2022-08-09
 * © Copyright 2022 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({globalScale, colors, fonts}) => {
  return {
    container: {
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 8,
    },
    sectionTitle: {
      fontSize: globalScale * 18,
      fontFamily: fonts.primaryBold,
      color: colors.white,
      marginVertical: globalScale * 16,
    },
    totalsHeader: {
      fontSize: 20,
      fontFamily: fonts.primaryBold,
      color: colors.accentDark,
      marginTop: globalScale * 8,
    },
    totalsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      columnGap: 16,
    },
    statWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
    statLabel: {
      color: colors.primaryExtraLight,
      marginRight: 8,
    },
    statText: {
      color: colors.accent,
      fontFamily: fonts.primaryBold,
    },
    editButton: {
      margin: 0,
    },

    syncNowButtonWrapper: {
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      flexWrap: 'wrap',
      marginTop: globalScale * 8,
      gap: globalScale * 8,
    },
    syncMessageText: {
      color: colors.complete,
      marginRight: globalScale * 8,
    },

    section: {
      display: 'flex',
      width: '100%',
      justifyContent: 'flex-start',
      alignItems: 'center',
      paddingHorizontal: 8,
    },
    titleAndAction: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    sectionInner: {
      width: '100%',
      maxWidth: 1000,
    },
    tickText: {
      fontSize: 14,
    },
    chartWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 16,
    },
    chart: {
      position: 'absolute', // @TODO: shouldn't need to be absolute (v3 requires this now to look right...that's why the margins are accounted for in left and top as well)
      top: 8,
      left: 8,
      backgroundColor: colors.primaryExtraDark,
      borderRadius: 4,
    },
    tooltip: {
      backgroundColor: colors.primaryExtraDark,
    },
    tooltipDate: {
      color: colors.white,
      backgroundColor: colors.primaryExtraDark,
    },
  };
};

export default getStyles;
